import {
  PRODUCT_MENU_INIT_LOADING,
  PRODUCT_MENU_INIT_SUCCESS,
  PRODUCT_MENU_INIT_FAIL,
  PRODUCT_MENU_LOADING,
  PRODUCT_MENU_SUCCESS,
  PRODUCT_MENU_FAIL,
  PRODUCT_STDCOMMDISCFACT,
  PRODUCT_STDCOMMDISCFACT_TABMENU,
  PRODUCT_STDCOMMDISCFACTORLIST
} from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
import http, { expandURI } from '@/utils/ajax'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  product: {
    init: 0,
    initErr: [],
    menu: {},
    appID: undefined,
    stdCommDiscFactorTabMenu: 0,
    stdCommDiscFactorDisplayFactReviewTab: false,
    stdCommDiscFactorDisplayRateTab: false,
    stdCommDiscFactorEffDate: undefined,
    stdCommDiscFactors: {
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null
    },
    factor1to3List: [],
    factor4to6List: []
  }
}

const getters = {

}

const mutations = {
  [PRODUCT_MENU_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [PRODUCT_MENU_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [PRODUCT_MENU_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [PRODUCT_MENU_LOADING](state) {
    state.product.init = 0
    state.product.initErr = []
    state.product.menu = {}

    state.product.appID = undefined
  },
  [PRODUCT_MENU_SUCCESS](state, data) {
    state.product.init = 1
    state.product.initErr = []
    state.product.menu = data.menu

    state.product.appID = data.data.appId
  },
  [PRODUCT_MENU_FAIL](state, error) {
    state.product.init = 2
    state.product.initErr = error
    state.product.menu = {}

    state.product.appID = undefined
  },
  [PRODUCT_STDCOMMDISCFACT_TABMENU](state, data) {
    state.product.stdCommDiscFactorTabMenu = data.stdCommDiscFactTab
    state.product.stdCommDiscFactorDisplayFactReviewTab = data.displayFactReviewTab
    state.product.stdCommDiscFactorDisplayRateTab = data.displayRateTab
    if (data.effDate) {
      state.product.stdCommDiscFactorEffDate = data.effDate
    }
  },
  [PRODUCT_STDCOMMDISCFACT](state, data) {
    if (data) {
      state.product.stdCommDiscFactors = data
    }
  },
  [PRODUCT_STDCOMMDISCFACTORLIST](state, data) {
    if (data) {
      state.product.factor1to3List = data.factor1to3List
      state.product.factor4to6List = data.factor4to6List
    }
  }
}

const actions = {
  async productInit({ commit, rootState }) {
    const apiUrl = rootState.parameters.menu.product
    if (apiUrl) {
      commit(PRODUCT_MENU_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(PRODUCT_MENU_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PRODUCT_MENU_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PRODUCT_MENU_INIT_FAIL, extractMessages(['Invalid API URL - Product Menu']))
    }
  },
  async productMenuInit({ commit, state }, xproduct) {
    const apiUrl = state.menu.productGet
    if (apiUrl) {
      commit(PRODUCT_MENU_LOADING)
      try {
        const expand = {
          product: xproduct
        }
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu,
          data: result.data.data.product
        }
        // refresh menu
        commit(PRODUCT_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(PRODUCT_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(PRODUCT_MENU_FAIL, extractMessages(['Invalid API URL - Product Menu']))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
